import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CompetenciesDescServices from "./competenciesDesc.services";
import gestorDocumentalServices from "../../gestorDocumental/gestorDocumental.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCompetenciesDesc = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC,
      payload: true,
    });
    const resp = await CompetenciesDescServices.getCompetenciesDesc(filters);
    dispatch({
      type: actions.GET_COMPETENCIES_DESC,
      payload: resp.data,
     
    }); console.log(resp.data);
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: '',
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC,
      payload: false,
    });
  }
};

export const resetCompetenciesDesc = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC,
      payload: true,
    });
    dispatch({
      type: actions.GET_COMPETENCIES_DESC,
      payload: {
        data: [],
        count: 0
      },
    });
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: '',
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC,
      payload: false,
    });
  }
};

export const getCompetencieDescById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC_BY_ID,
      payload: true,
    });
    const resp = await CompetenciesDescServices.getCompetencieDescById(id);
    dispatch({
      type: actions.GET_COMPETENCIES_DESC_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: '',
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC_BY_ID,
      payload: false,
    });
  }
};

export const saveCompetencieDesc = (_data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COMPETENCIES_DESC,
      payload: true,
    });
    const {req, reqDoc} = _data;
    const repGD = await gestorDocumentalServices.saveCompetenciesDocument(reqDoc);
    req.archivo = repGD.data.resultado.id;
    const resp = await CompetenciesDescServices.saveCompetencieDesc(req);
    const { data, count } = getState().competenciesDesc.competenciesDesc;
    dispatch({
      type: actions.GET_COMPETENCIES_DESC,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_COMPETENCIES_DESC_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else if(ex.response.data && ex.response.data.resultado && ex.response.data.resultado[0].response){
              message = ex.response.data.resultado[0].response;
            }else{
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_COMPETENCIES_DESC_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_COMPETENCIES_DESC,
      payload: false,
    });
  }
};

export const editCompetencieDesc = (dataE, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_COMPETENCIES_DESC,
      payload: true,
    });
    const {req, reqDoc} = dataE;
    if (reqDoc){
      await gestorDocumentalServices.editCompetenciesDocument(reqDoc.id, reqDoc);
    }
    const resp = await CompetenciesDescServices.editCompetencieDesc(dataE.id, req);
    const { data, count } = getState().competenciesDesc.competenciesDesc;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_COMPETENCIES_DESC,
      payload: {
        data: _data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_COMPETENCIES_DESC_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else if(ex.response.data && ex.response.data.resultado && ex.response.data.resultado[0].response){
              message = ex.response.data.resultado[0].response;
            }else{
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_COMPETENCIES_DESC_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_COMPETENCIES_DESC,
      payload: false,
    });
  }
};

export const deleteCompetenciesDesc = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC,
      payload: true,
    });
    await CompetenciesDescServices.deleteCompetencieDesc(id);
    const { data, count } = getState().competenciesDesc.competenciesDesc;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_COMPETENCIES_DESC,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPETENCIES_DESC_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_COMPETENCIES_DESC,
      payload: false,
    });
  }
};
